import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../auth/AuthContext';
import api from '../utils/api';
import { organizationKeys } from '../utils/queryClient';

export function useMyOrganization(options = {}) {
    const { user } = useAuth();

    return useQuery({
        queryKey: organizationKeys.my(),
        queryFn: () => api.getMyOrganization(),
        staleTime: 1000 * 60 * 2,
        enabled: !!user,
        ...options
    });
}

export default useMyOrganization;
